module.exports = __webpack_public_path__ + "static/media/vaneyk-9.ead12de9.jpeg";